// @flow

import SlingApiSdk from 'sling-calendar-sdk/SlingApi';
import { from } from 'rxjs';

import apiProxySdk from './apiProxySdk';

const sdkApi: { [string]: any } = new SlingApiSdk(apiProxySdk);

function fromPromiseDecorator(fn: (...args: any) => any): any {
  return (...params: Array<any>) => {
    const originalResult = fn(...params);
    return originalResult && originalResult.then
      ? from(originalResult)
      : from(new Promise(resolve => resolve(originalResult)));
  };
}

const SlingApi: { [string]: any } = {};
Object.getOwnPropertyNames(Object.getPrototypeOf(sdkApi)).forEach(method => {
  SlingApi[method] = fromPromiseDecorator(sdkApi[method].bind(sdkApi));
});

Object.getOwnPropertyNames(sdkApi).forEach(method => {
  SlingApi[method] = fromPromiseDecorator(sdkApi[method].bind(sdkApi));
});

export default SlingApi;
